import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly _title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);

    if (!title) return;

    const isAuthRoute = snapshot.url.includes('/auth');

    if (isAuthRoute) {
      this._title.setTitle(title);
    } else {
      this._title.setTitle(`باکارت | ${title}`);
    }
  }
}
